import Constants from '../../config.local.js'
import Accounting from '@/mixins/Accounting.js'
import Gynecologie from '@/mixins/Gynecologie.js'
import Horse from '@/mixins/Horse.js'

var DashboardMixin = {
    mixins: [Accounting, Gynecologie, Horse],
	methods: {
        createDashboard: async function(dashboards_name, dashboards_is_default, dashboards_shared_users, widgets = []) {
            const url = this.constructRoute(Constants.DASHBOARD_URL, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const infos = { dashboards_name, dashboards_is_default, dashboards_shared_users, widgets }

            const response = await this.$request.request_post_api("DashboardMixin::createDashboard", url, infos, false)
            .catch(e => {
                console.error("DashboardMixin::createDashboard", e)
                this.failureToast("toast.info_save_failed")
            })

            return response
        },
        getDashboards: async function() {
            const url = this.constructRoute(Constants.DASHBOARD_URL, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const response = await this.$request.request_get_api("DashboardMixin::getDashboards", url, false)
            .catch(e => {
                console.error("DashboardMixin::getDashboards", e)
                this.failureToast("toast.info_get_failed")
            })

            return response.retour
        },
        updateDashboard: async function(dashboard_id, data) {
            const url = this.constructRoute(Constants.DASHBOARD_ID_URL, {dashboard_id}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const response = await this.$request.request_post_api("DashboardMixin::updateDashboard", url, data, false)
            .catch(e => {
                console.error("DashboardMixin::updateDashboard", e)
                this.failureToast("toast.info_save_failed")
            })

            return response
        },
        deleteDashboard: async function(dashboard_id) {
            const url = this.constructRoute(Constants.DASHBOARD_ID_URL, {dashboard_id}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const response = await this.$request.request_delete_api("DashboardMixin::deleteDashboard", url, false)
            .catch(e => {
                console.error("DashboardMixin::deleteDashboard", e)
                this.failureToast("toast.info_save_failed")
            })

            return response
        },
        getWidgetTypes: async function() {
            const url = this.constructRoute(Constants.WIDGET_TYPES_URL, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            const response = await this.$request.request_get_api("DashboardMixin::getWidgetTypes", url, false)
            .catch(e => {
                console.error("DashboardMixin::getWidgetTypes", e)
                this.failureToast("toast.info_get_failed")
            })

            return response.retour
        },
		getAllEntites: async function() {
			const entites = await this.loadAccountingPlans()
			return entites.map(e => ({
				code: e.accountingplan_id,
				label: e.accountingplan_label,
				currency: e.tiers.tiers_currency,
			}))
		},
		getAllSeasonOptions: async function() {
			const seasons = await this.loadSeasons()
			return seasons.map(s => ({
				code: s.season_id,
				label: s.season_label,
			}))
		},
		getAllStallionOptions: async function() {
			const horses = await this.getHorsesStallion(false)
			return horses.map(h => ({
				code: h.horse_id,
				label: h.horse_nom,
			}))
		},
		getContractStatsMap: async function(params = {}) {
			let url = this.constructRoute(Constants.CONTRACT_STATS_MAP_URL, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY
			if (params.saison) url += "&season_id=" + params.saison
			if (params.etalon) url += "&stallion_id=" + params.etalon
			for (const s of params.statuts) url += "&statuts[]=" + s
			for (const t of params.types_monte) url += "&types_monte[]=" + t
			const response = await this.$request.request_get_api("DashboardMixin::getContractStatsMap", url, false)
				.catch(e => {
					console.error("DashboardMixin::getContractStatsMap", e)
					return null
				})
			return response.retour
		},
    }
}

export default DashboardMixin
